// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"97":"Profile","333":"CV","337":"Contact","894":"Story"}[chunkId] + "." + {"97":"cfe85942","333":"2c021968","337":"760504d6","894":"1dee4bee"}[chunkId] + ".js";
};